import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface ToursState {
  isValidatorTourRun: boolean;
  stepIndex: number;
  totalSteps: number;
  tourActive: boolean;
  pendingNavigation: string | null;
  setIsValidatorTourRun: (isValidatorTourRun: boolean) => void;
  setStepIndex: (stepIndex: number) => void;
  setTotalSteps: (totalSteps: number) => void;
  setTourActive: (tourActive: boolean) => void;
  setPendingNavigation: (route: string | null) => void;
  resetTour: () => void;
  getProgress: () => number;
}

export const useToursStore = create<ToursState>()(
  devtools(
    persist(
      immer((set, get) => ({
        isValidatorTourRun: false,
        stepIndex: 0,
        totalSteps: 0,
        tourActive: false,
        pendingNavigation: null,
        setIsValidatorTourRun: (isValidatorTourRun: boolean) =>
          set((state) => {
            state.isValidatorTourRun = isValidatorTourRun;
            if (isValidatorTourRun) {
              state.tourActive = true;
              state.stepIndex = 0;
            }
          }),
        setStepIndex: (stepIndex: number) =>
          set((state) => {
            state.stepIndex = stepIndex;
          }),
        setTotalSteps: (totalSteps: number) =>
          set((state) => {
            state.totalSteps = totalSteps;
          }),
        setTourActive: (tourActive: boolean) =>
          set((state) => {
            state.tourActive = tourActive;
          }),
        setPendingNavigation: (route: string | null) =>
          set((state) => {
            state.pendingNavigation = route;
          }),
        resetTour: () =>
          set((state) => {
            state.isValidatorTourRun = false;
            state.stepIndex = 0;
            state.totalSteps = 0;
            state.tourActive = false;
            state.pendingNavigation = null;
          }),
        getProgress: () => {
          const { stepIndex, totalSteps } = get();
          if (totalSteps === 0) return 0;
          return Math.min(
            100,
            Math.round(((stepIndex + 1) / totalSteps) * 100)
          );
        },
      })),
      {
        name: 'tours-state',
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
);
